import { AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from 'react-query';
import planService from '../../services/planService';
import { IPlanDTO } from '../../shared/interfaces/plan-interfaces';

enum ServiceKeys {
  listPlans = 'listPlans',
  choosePlan = 'choosePlan',
}

const fetchPlans = async () => {
  const response = await planService.list();

  return response.data;
};

export const useGetPlans = (): UseQueryResult<IPlanDTO[]> => {
  return useQuery(ServiceKeys.listPlans, fetchPlans);
};

interface IChoosePlan {
  onSuccess?: () => {};
}

export const useChoosePlan: (
  prop: IChoosePlan,
) => UseMutationResult<AxiosResponse, Error, any> = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  return useMutation((planId: number) => planService.choosePlan(planId), {
    onSuccess: () => {
      queryClient.invalidateQueries(ServiceKeys.choosePlan);
      if (onSuccess) onSuccess();
    },
  });
};
